import { render, staticRenderFns } from "./generateReport.vue?vue&type=template&id=5d0971b6"
import script from "./generateReport.vue?vue&type=script&lang=js"
export * from "./generateReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports